import React from 'react';

import GenderSwitcherRadioButton from './GenderSwitcherRadioButton';
import GenderResourceType from './../../types/GenderResourceType';

/**
 * Gender Switcher component
 */
const GenderSwitcher = (props) => {
  const {selected, clicked} = props;
  const {label, data} = props.data;

  return(
    <div className="nppe2-fc-gender-switcher">

      <div className="nppe2-fc-sub-title">
        {label}
      </div>

      <div className="nppe2-fc-radio-buttons">
        {Object.keys(data).map(key => (
          <GenderSwitcherRadioButton
            key={data[key]}
            data={data[key]}
            value={key}
            selected={selected}
            clicked={clicked}
          />
        ))}
      </div>
    </div>
  );
};

GenderSwitcher.propTypes = GenderResourceType;

export default GenderSwitcher;
